import { render, staticRenderFns } from "./AllWarehouses.vue?vue&type=template&id=de2d3108"
import script from "./AllWarehouses.vue?vue&type=script&lang=js"
export * from "./AllWarehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports